import { StompClient } from '@websocket/types/WebsocketTypes';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Client } from '@stomp/stompjs';

const initialState: StompClient = {
  connected: false,
  client: null,
};

const websocketSlice = createSlice({
  name: 'websocket',
  initialState,
  reducers: {
    setConnected: (state, action: PayloadAction<boolean>) => {
      state.connected = action.payload;
    },
    setClient: (state, action: PayloadAction<Client | null>) => {
      state.client = action.payload;
    },
  },
});

export const { setConnected, setClient } = websocketSlice.actions;

export default websocketSlice.reducer;
